type LtrPreserverProps = { children?: string };

export default function LtrPreserver({ children }: LtrPreserverProps) {
  return <span dir="ltr">{children}</span>;
}
